import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { authService } from '../../common/services/authService';

export default function LogoutPage() {
  const history = useHistory();

  useEffect(() => {
    authService.setLoggedOut();
    history.push('/auth/login');
  }, []);

  return (
    <div>You are now logged out</div>
  );
}
